import { useMemo } from "react";
import { Box, Drawer, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import launchpadItems from "../consts/launchpadItems.js";
import { useNavigate } from "react-router-dom";
import * as classes from "./nav-styles.module.css";
import IfRole from "../IfRole.js";

export default function NavDrawer({ toggleDrawer, open }) {
  const nav = useNavigate();

  const items = useMemo(() => {
    return launchpadItems.map((item) => (
      <IfRole route={item.route} key={item.title}>
        <ListItem className={classes.navItem} onClick={() => nav(item.route)}>
          <ListItemIcon className={classes.navIcon}>{item.icon}</ListItemIcon>
          <ListItemText className={classes.navText}>{item.title}</ListItemText>
        </ListItem>
      </IfRole>
    ));
  }, []);

  return (
    <Box
      sx={{
        width: 250,
      }}
      role="presentation"
      // onClick={() => toggleDrawer(false)}
      className="focus-visible:none"
    >
      
      <Drawer open={open} anchor="left" onClose={() => toggleDrawer(false)} className="focus-visible:none">
        <List
          sx={{
            backgroundColor: "#fff",
            filter: "drop-shadow(0px 0px 0px #231d2ee3)",
            backdropFilter: "blur(0.1rem)",
            padding: "1rem"
          }}
          className={classes.primaryNavigation}
        >
          <ListItem className={classes.navItem} onClick={() => nav("/main/launchpad" )}>
            {/* <ListItemIcon className={classes.navIcon}></ListItemIcon> */}
            <div className={classes.navIcon}>
              <svg viewBox="0 0 24 24"><title>home</title><path  className="fill-slate-gray" d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z" /></svg>
            </div>
            <ListItemText className={classes.navText}>Launchpad</ListItemText>
          </ListItem>
          {items}
        </List>
      </Drawer>
    </Box>
  );
}
